import type { ButtonHTMLAttributes } from "react";
import { Spinner } from "./Spinner";

type Variant = "primary" | "secondary" | "ghost" | "danger";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  block?: boolean;
  small?: boolean;
  busy?: boolean;
}

export function Button({ variant = "primary", block, small, busy, className, children, disabled, ...rest }: ButtonProps) {
  const cls = ["btn", `btn--${variant}`, block && "btn--block", small && "btn--sm", className].filter(Boolean).join(" ");
  return (
    <button type="button" className={cls} disabled={disabled || busy} aria-busy={busy || undefined} {...rest}>
      {busy && <Spinner small />}
      {children}
    </button>
  );
}
